import React from 'react';
// import { useMediaQuery } from 'react-responsive';
import ActionHeader from '../../components/actionHeader';
import { PrimaryButton, SecondaryButton } from '../../components/buttons';
// import { mobileBreakpoint } from '../../lib';

function Header({ heading, userId, subHeading, handleOpenSaveModal, handleOpenExitModal, userCanSave }){
    // const isMobile = useMediaQuery({ maxWidth: mobileBreakpoint });
    return (
        <ActionHeader 
            heading={heading}
            subHeading={subHeading}
            handleOpenExitModal={handleOpenExitModal}
        >
            {userCanSave && <PrimaryButton margin="0 40px 0 0" onClick={handleOpenSaveModal}>Save Results</PrimaryButton>}
            <SecondaryButton onClick={handleOpenExitModal}>Exit</SecondaryButton>
        </ActionHeader>
    );
}

export default Header;